export class Telefones {
  celular: string;
  residencial: string;
  comercial: string;
}
